<script>

    export default {
        name: "NegotiationsItem",
        props: {
            item: {
                type: Object,
                default: () => {}
            }
        },
        data () {
            return {
                totalPrice: '',
                expiresIn: 1
            }
        },
        computed: {
            userType () {
                return this.$store.getters['user/userType'];
            },
            hasImage () {
                // TODO
                return false;
            },
            expiresInText () {
                if(this.expiresIn === 1) {
                    return 'Expires Today'
                } else if (this.expiresIn > 0) {
                    return `Expires in ${this.expiresIn} days`
                } else {
                    return 'Expired'
                }
            }
        },
        async mounted () {
            if (this.item.offer_expires_at) {
                this.expiresIn = this.calculateExpiration();
            }
        },
        methods: {
           calculateExpiration () {
                const date1 = new Date(this.item.offer_expires_at);
                const date2 = new Date();
                const diffTime = Math.abs(date2 - date1);
                return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            },
            openModal () {
               this.$emit('click', this.item._id);
            }
        }
    }
</script>

<template>
    <div @click="openModal" class="card agreement-box tab-section p-0">
        <div v-if="hasImage" class="card-top-image-container" :style="{ backgroundImage: `url('https://picsum.photos/300/300')` }">

        </div>
        <div class="card-body body-padding">
            <div class="float-right ml-2">
                      <span
                              class="badge badge-pill font-size-12"
                              :class=" {
                            'badge-soft-primary': `${item.status}` === 'offer',
                            'badge-warning': `${item.status}` === 'interested',
                            'badge-primary': `${item.status}` === 'pending',
                            'badge-soft-danger': `${item.status}` === 'canceled',
                            'badge-success': `${item.status}` === 'signed',
                            // add fake-class to prevent overriding same class names
                            'badge-soft-danger fake-class': `${item.status}` === 'aborted',
                            'badge-secondary': `${item.status}` === 'expired' }"
                      >
                          {{ (item.status.charAt(0).toUpperCase() + item.status.slice(1)).replace(/_/g, " ") }}
                      </span>
            </div>
            <div>
                <h5 class="font-size-15 text-dark">
                     {{ item.campaign_name }}
                </h5>
            </div>
            <div class="text-muted mb-4 d-flex justify-content-between">
                <span>
                    <i class="far fa-calendar-alt"></i>
                    {{ new Date(item.campaign_date).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) }}
                </span>
                <p v-if="item.status === 'offer'" :class="[ expiresIn === 1 ? 'text-danger' : 'text-muted']">
                    <i class="fas fa-clock"></i> {{ expiresInText }}
                </p>
            </div>
            <div class="row justify-content-end">
                <div class="col d-flex align-items-center">
                    <div v-if="item.notifications" class="notification d-flex align-items-center justify-content-center badge badge-danger mr-1 mr-xl-2 px-1">
                        <i  class="bx bx-bell" style="font-size: 16px;"></i>
                        <span class="notification-number mx-1">{{ item.notifications.length }}</span>
                    </div>
                    <div v-if="item.comments_count" class="notification d-flex align-items-center justify-content-center badge text-muted mr-1 mr-xl-2">
                        <i  class="bx bx-comment" style="font-size: 16px;"></i>
                        <span class="notification-number mx-1">{{ item.comments_count }}</span>
                    </div>
                    <div v-if="item.scheduled_posts_count" class="notification d-flex align-items-center justify-content-center badge text-muted mr-1 mr-xl-2">
                        <i  class="bx bx-calendar-check" style="font-size: 17px;"></i>
                        <span class="notification-number mx-1">{{ item.scheduled_posts_count }}</span>
                    </div>
                </div>
                <div class="col-auto text-right d-flex direction align-items-center justify-content-end">
                    <h5 v-if="(userType === 'client' || userType === 'admin') && item.campaign_agreement_grand_total_price" class="font-size-15 mb-0"> &euro; {{ item.campaign_agreement_grand_total_price.toLocaleString() }}</h5>
                    <h5 v-else-if="userType === 'influencer' && item.campaign_agreement_net_price" class="font-size-15 mb-0"> &euro; {{ item.campaign_agreement_net_price.toLocaleString() }}</h5>
                    <i v-else class="mdi mdi-account-question" style="font-size: 26px;"></i>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row m-0 justify-content-end">
                <div class="col p-0 d-flex align-items-center">
                    <img v-if="item.picture_url" :src="item.picture_url" class="rounded-circle avatar-xs" alt />
                    <div v-else-if="item.picture_alt" class="media-object avatar-xs letter-in-circle">{{ item.picture_alt.charAt(0) }}</div>
                    <div class="d-flex align-items-center justify-content-center badge">
                        <span class="notification-number mx-1">{{ item.picture_alt }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
